import React, { useCallback, useEffect, useState } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { clabe } from 'clabe-validator'
import formStyles from '../form.module.css'
import styles from './clabe-field.module.css'
import { formatCLABE } from './format-clabe'
import Iconify from '../../../../Iconify'
import iconoBanco from '../../../assets/icono-banco.png'

const MAX_DIGITS = 18
const MAX_INPUT_LEN = 23

const BankCheckIcon = () => (
  <span className={`${styles.suffix} ${styles.fadeIn}`}>
    <Iconify icon="mdi:bank-check" style={{ fontSize: 16, color: '#97ff48' }} />
  </span>
)

export const ClabeField = ({
  name = 'clabe',
  label = 'CLABE',
  helpText = '',
  required = false,
  placeholder = 'Número de tu cuenta CLABE'
}) => {
  const [clabeInfo, setClabeInfo] = useState(null)
  const { control, setError, clearErrors, formState } = useFormContext()
  const { isSubmitted } = formState

  const syncSubmitError = useCallback(
    (info) => {
      window.setTimeout(() => {
        if (isSubmitted && !info?.formatOk) {
          setError(name, {
            type: 'validationError',
            message: 'El número de cuenta CLABE no es válido'
          })
        } else {
          clearErrors(name)
        }
      }, 0)
    },
    [isSubmitted, name, setError, clearErrors]
  )

  useEffect(() => {
    syncSubmitError(clabeInfo)
  }, [isSubmitted, clabeInfo?.formatOk, clabeInfo, syncSubmitError])

  const handleChange = (field) => (event) => {
    const digitsOnly = event.target.value.replace(/\D/g, '').slice(0, MAX_DIGITS)
    const info = clabe.validate(digitsOnly)
    setClabeInfo(info)
    field.onChange(digitsOnly)
    syncSubmitError(info)
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState }) => {
        const displayValue = formatCLABE(field.value ?? '')

        return (
          <div className={formStyles.field}>
            <label className={formStyles.label} htmlFor={name}>
              {label}{' '}
              {required && <span className={formStyles.required}>*</span>}
            </label>

            <div
              className={`${formStyles.shell} ${fieldState.error ? styles.shellInvalid : ''}`}
            >
              <span className={formStyles.prefix}>
                <img src={iconoBanco} alt="Banco" height={17} />
              </span>
              <input
                id={name}
                ref={field.ref}
                name={field.name}
                className={formStyles.input}
                type="tel"
                inputMode="numeric"
                autoComplete="off"
                maxLength={MAX_INPUT_LEN}
                placeholder={placeholder}
                value={displayValue}
                onBlur={field.onBlur}
                onChange={handleChange(field)}
              />
              {clabeInfo?.formatOk ? <BankCheckIcon /> : null}
            </div>

            {clabeInfo?.formatOk && clabeInfo.bank ? (
              <div className={`${styles.meta} ${styles.fadeIn}`}>
                <Iconify icon="ooui:success" style={{ fontSize: 17, color: '#97ff48' }} />
                <span>{clabeInfo.bank}</span>
                {clabeInfo.city ? (
                  <span className={styles.metaCity}>{clabeInfo.city}</span>
                ) : null}
              </div>
            ) : null}

            {fieldState.error && (
              <p className={formStyles.error}>{fieldState.error.message}</p>
            )}

            {helpText && <p className={formStyles.helpText}>{helpText}</p>}
          </div>
        )
      }}
    />
  )
}
